<template>
  <div id="event">
    <h4>Last Updated: {{ lastUpdated }}</h4>
    <p></p>
    <p>
      This data is provided to you by the CHIME/FRB collaboration. If you use
      this data, please use the following acknowledgement: <br />
      <b style="color:green"
        >We acknowledge use of the CHIME/FRB Public Database, provided at
        https://www.chime-frb.ca/ by the CHIME/FRB Collaboration.</b
      >
    </p>
    <h2 style="margin-bottom: 30px">
      Showing {{ $route.params.id }} ({{ items.length }} bursts)
    </h2>
    <div role="tablist">
      <b-container style="margin-top: 20px">
        <b-row align-v="left">
          <b-col lg="12">
            <details open="true">
              <summary style="font-size:30px; text-align:left"
                >Localization</summary
              >
              <a
                class="download-button"
                :href="links.localization_contour"
                :download="source_name"
              >
                <b-button variant="dark">
                  Download Localization Data
                </b-button>
              </a>
              <b-link v-bind:href="links.localization" target="_blank">
                <b-img-lazy
                  :src="links.localization"
                  width="600px"
                  alt="coming soon..."
                  fluid
                  center
                />
              </b-link>
            </details>
          </b-col>
        </b-row>
        <!--<b-row align-v="center">
              <b-col lg=3></b-col>
              <b-col lg="6">
              <details>
              <summary style="font-size:30px">DM Excess Map</summary>
                <b-link v-bind:href=links.dm_map target="_blank">
                <b-img-lazy :src=links.dm_map
                  alt="DM map was not found"        
                />
                </b-link>
              </details>
              </b-col>
              <b-col lg=3></b-col>
            </b-row>-->
      </b-container>
      <b-container>
        <div>
          <h2 align="left" style="margin-top: 30px">
            Burst Parameters:
            <span style="font-size:20px; color: green"
              >(Information will be added as soon as becomes available)</span
            >
          </h2>
        </div>
        <div v-if="items.length != 0" id="table">
          <div v-if="items.length > 5" id="table">
            <b-row>
              <b-col md="2" class="my-1">
                <b-form inline>
                  <label class="mr-sm-2"> Per page </label>
                  <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form>
              </b-col>
              <b-col md="4" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                />
              </b-col>
              <b-col md="2" class="my-1"> </b-col>
              <b-col md="4" class="my-1">
                <div style="float:right">
                  <b-form inline>
                    <label class="mr-sm-2">Filter:</label>
                    <b-input-group>
                      <b-form-input
                        v-model="filter"
                        placeholder="Type to Search"
                      />
                      <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''"
                          >Clear</b-btn
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-table
            hover
            striped
            outlined
            v-if="items.length != 0"
            :stacked="md"
            :fields="fields"
            :items="filteredItems"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template v-slot:cell(action)="data">
              <div class="zoom" v-if="data.item.waterfall != ''">
                <b-link v-bind:href="data.item.waterfall" target="_blank">
                  <b-img-lazy
                    :src="data.item.waterfall"
                    width="50px"
                    height="50px"
                  />
                </b-link>
              </div>
            </template>
            <template v-slot:head(dm)="data">
              {{ data.label }} (pc cm<sup>-3</sup>)
            </template>
            <template v-slot:cell(dm)="data">
              {{ data.item.dm }}
              <span v-if="checkIfDisplay(data.item.dm_error.error_high)"
                ><span style="font-size: 80%"
                  >({{ data.item.dm_error.error_high }})</span
                ></span
              >
            </template>
            <template v-slot:cell(flux)="data">
              {{ data.item.flux }}
              <span v-if="checkIfDisplay(data.item.flux_error.error_high)"
                ><span style="font-size: 80%"
                  >({{ data.item.flux_error.error_high }})</span
                ></span
              >
            </template>
            <template v-slot:cell(fluence)="data">
              {{ data.item.fluence }}
              <span v-if="checkIfDisplay(data.item.fluence_error.error_high)"
                ><span style="font-size: 80%"
                  >({{ data.item.fluence_error.error_high }})</span
                ></span
              >
            </template>
            <template v-slot:cell(width)="data">
              {{ data.item.width }}
              <span v-if="checkIfDisplay(data.item.width_error.error_high)"
                ><span style="font-size: 80%;"
                  >({{ data.item.width_error.error_high }})</span
                ></span
              >
            </template>
            <template v-slot:cell(scattering_time)="data">
              {{ data.item.scattering_time }}
              <span
                v-if="
                  checkIfDisplay(data.item.scattering_time_error.error_high)
                "
                ><span style="font-size: 80%">
                  ({{ data.item.scattering_time_error.error_high }})</span
                ></span
              >
            </template>
          </b-table>
        </div>
        <div v-else>
          <p>Loading...</p>
          <b-spinner
            v-for="variant in variants"
            :variant="variant"
            :key="variant"
            type="grow"
          ></b-spinner>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { filterMixin } from "./mixins/filter_mixin.js";
export default {
  name: "event",
  mixins: [filterMixin],
  data() {
    return {
      fields: [
        {
          key: "burst_id",
          label: "Burst ID",
          sortable: true,
        },
        {
          key: "date_utc",
          label: "Date",
          sortable: true,
        },
        {
          key: "time_utc",
          label: "UTC (Topocentic) @400MHz",
          sortable: true,
        },
        {
          key: "dm",
          label: "DM",
          sortable: true,
        },
        {
          key: "snr",
          label: "SNR",
          sortable: true,
        },
        // {key: 'ra', label: 'RA'},
        // {key: 'dec', label: 'Dec'},
        {
          key: "fluence",
          label: "Fluence (Jy ms)",
          sortable: true,
        },
        {
          key: "flux",
          label: "Flux (Jy)",
          sortable: true,
        },
        {
          key: "width",
          label: "width (ms)",
          sortable: true,
        },
        {
          key: "scattering_time",
          label: "Scattering Time (ms)",
          sortable: true,
        },
        {
          key: "action",
          label: "Waterfall Plot",
        },
      ],
      links: {},
      source_name: "",
      sortBy: "date_utc",
      sortDesc: true,
    };
  },
  mounted() {
    // var url = 'http://localhost:8081/source'
    var url = "https://catalog.chime-frb.ca/source";
    this.fetchSources(url);
    this.fetchLastUpdated("frbs");
  },
  computed: {},
  methods: {
    fetchSources(url) {
      return this.$http
        .post(url, {
          user_email: localStorage.user_email,
          source: this.$route.params.id,
        })
        .then((response) => {
          if (response.body) {
            this.parseResponse(response.body);
          }
        });
    },
    parseResponse(sources) {
      var sourceNames = Object.keys(sources);
      this.totalRows = sourceNames.length;
      var base_link =
        "https://storage.googleapis.com/chimefrb-dev.appspot.com/" +
        sourceNames[0];
      // var burst = Object.keys(sources[sourceNames[0]])[0]
      var datetime = new Date(date_string);
      var bursts = Object.keys(sources[sourceNames[0]]);
      var baseFrbParams = [
        "ra",
        "dec",
        "publication",
        "localized",
        "last_burst_date",
        "gl",
        "gb",
        "ne2001",
        "ymw16",
        "dm",
        "previous_name",
      ];
      for (var i = 0; i < bursts.length; i++) {
        if (baseFrbParams.includes(bursts[i])) {
          continue;
        }
        var burst = bursts[i];
        var item = {};
        item["source_id"] = sourceNames[0];
        item["burst_id"] = burst;
        item["dm"] = sources[sourceNames[0]][burst]["dm"].value;
        item["dm"] = ["string", "number"].includes(typeof item["dm"])
          ? item["dm"].toFixed(1)
          : "";
        item["dm_error"] = sources[sourceNames[0]][burst]["dm"];
        item["dm_error"]["error_high"] = Object.keys(item["dm_error"]).includes(
          "error_high"
        )
          ? item["dm_error"]["error_high"].toFixed(1)
          : "";
        item["snr"] = sources[sourceNames[0]][burst]["snr"].value.toFixed(1);
        item["snr"] = ["string", "number"].includes(typeof item["snr"])
          ? item["snr"]
          : "";
        item["width"] = sources[sourceNames[0]][burst]["width"].value;
        item["width"] = ["string", "number"].includes(typeof item["width"])
          ? item["width"]
          : "";
        item["width_error"] = sources[sourceNames[0]][burst]["width"];
        item["width_error"]["error_high"] = Object.keys(
          item["width_error"]
        ).includes("error_high")
          ? item["width_error"]["error_high"]
          : "";
        item["scattering_time"] =
          sources[sourceNames[0]][burst]["scattering_time"].value;
        item["scattering_time"] = ["string", "number"].includes(
          typeof item["scattering_time"]
        )
          ? item["scattering_time"]
          : "";
        item["scattering_time_error"] =
          sources[sourceNames[0]][burst]["scattering_time"];
        item["scattering_time_error"]["error_high"] = Object.keys(
          item["scattering_time_error"]
        ).includes("scattering_time_high")
          ? item["width_error"]["error_high"]
          : "";
        item["flux"] = sources[sourceNames[0]][burst]["flux"].value;
        item["flux"] = ["string", "number"].includes(typeof item["flux"])
          ? item["flux"]
          : "";
        item["flux_error"] = sources[sourceNames[0]][burst]["flux"];
        item["flux_error"]["error_high"] = Object.keys(
          item["flux_error"]
        ).includes("error_high")
          ? item["flux_error"]["error_high"]
          : "";
        item["fluence"] = sources[sourceNames[0]][burst]["fluence"].value;
        item["fluence"] = ["string", "number"].includes(typeof item["fluence"])
          ? item["fluence"]
          : "";
        item["fluence_error"] = sources[sourceNames[0]][burst]["fluence"];
        item["fluence_error"]["error_high"] = Object.keys(
          item["fluence_error"]
        ).includes("error_high")
          ? item["fluence_error"]["error_high"]
          : "";
        // item['ra'] = sources[sourceNames[0]][burst]['ra'].value
        // item['dec'] = sources[sourceNames[0]][burst]['dec'].value
        var date_string = sources[sourceNames[0]][burst]["timestamp"].value;
        date_string = ["string", "number"].includes(typeof date_string)
          ? date_string
          : "";
        item["date_no_time"] = date_string.split(" ")[0];
        item["time"] = date_string.split(" ")[0].split(".")[0];
        item["date"] = datetime;
        item["date_utc"] = date_string.split(" ")[0];
        item["time_utc"] = date_string.split(" ")[1]; //.split('.')[0]
        if (
          item["flux"] == "" &&
          item["width"] == "" &&
          item["scattering_time"] == ""
        ) {
          item["waterfall"] = "";
        } else {
          item["waterfall"] = base_link + "/" + burst + "_waterfall.png";
        }
        this.items.push(item);
      }
      // var base_link = 'http://localhost:8081/' + burst
      // var base_link = 'https://catalog.chime-frb.ca/' + burst
      this.source_name = sourceNames[0] + "_localization_contour.pkl";
      this.links["localization"] = base_link + "/localization.png";
      this.links["localization_contour"] =
        base_link + "/localization_contour.pkl";
      this.links["dm_map"] = base_link + "/dm_map.png";
      this.filterItems();
      this.whichEvents = "Repeaters";
    },
    filterItems() {
      console.log("filtering items");
      // Filters the master list and generates a list of filtered items
      this.whichEvents = "Filtered";
      this.noResultsFound = false;
      this.filteredItems = [];
      // Loop through the master list, check if each item is to be added based on the first burst parameters,
      // parse added items a bit
      for (var i = 0; i < this.items.length; i++) {
        this.filteredItems.push(this.items[i]);
      }
      this.totalRows = this.filteredItems.length;
      console.log(this.totalRows);
      if (this.filteredItems.length == 0) {
        this.noResultsFound = true;
      }
    },
  },
};
</script>
<style>
.zoom {
  transition: transform 0s;
  /* Animation */
  width: 50px;
  height: 50px;
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(5);
}
</style>
